/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._SubmitButton_ocmdr_32 ._spinner_ocmdr_32 {
  color: #3996e0;
}
._SubmitButton_ocmdr_32 ._spinner_ocmdr_32._white_ocmdr_35 {
  color: #fdfdfd;
}